import React, { useEffect, useState } from "react";
import "./overview.scss";
import Chart from "react-apexcharts";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../../firebase/firebase";
import { useNavigate } from "react-router-dom";
import {
  approveFtTokens,
  getTokenBalance,
  getOwnerRentProfit
} from "../../contractInteraction/contractInteraction";
import { useAccount, useWalletClient } from "wagmi";

const Overview = () => {
  const [userisLogged, setUserisLogged] = useState();
  const [tokenBalance, setTokenBalance] = useState(0);
  const { data: signer } = useWalletClient();
  const { address } = useAccount();
  const [profit, setProfit] = useState("");
  const options = {
    xaxis: {
      categories: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    },
    colors: ["#D501FA", "#ffffff", "#ffffff"], // Specify colors for each series
    chart: {
      toolbar: {
        show: false, // Hide the toolbar (including zoom icons and other controls)
      },
    },
    zoom: {
      enabled: false, // Disable zoom functionality
    },
  };
  const series = [
    {
      name: "s1",
      data: [0, String(profit) ? profit : 0],
    },
  ];
  const navigate = useNavigate()
  const handleTokensApproval = async () => {
    await approveFtTokens(signer)
      .then(async (res) => {
        console.log(res);
        if (res.success) {
          console.log("Token Approved Successfully");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  const getBalance = async () => {
    const tokenBalanceGot = await getTokenBalance(address);
    const twoDecimalBalance = parseFloat(tokenBalanceGot).toFixed(2);
    setTokenBalance(twoDecimalBalance);
  }

  const getProfit = async () => {
    const rentProfit = await getOwnerRentProfit(address);
    console.log("ddd", rentProfit)
    setProfit(rentProfit);
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const { uid } = user;
        setUserisLogged(user);

      } else {
        setUserisLogged(user);
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    getBalance();
    getProfit();
  }, [])


  return (
    <>
      <div className="profile-overview">
        <div className="top-wrapper">
          <div className="profile-account content-wrapper">
            <div className="left">
              <div className="profile-img cursor-pointer ">
                <img
                  src={userisLogged?.photoURL ? userisLogged?.photoURL : "/assets/images/profilePlaceholder.jpg"}
                  alt="user profile"
                  className="img-100"
                  style={{ borderRadius: "10px" }}
                />
                {/* <p className="para v-center ps-2">Edit Profile Picture</p> */}
              </div>
            </div>
            <div className="right w-100">
              <h2 className="body-medium text-center ">account</h2>
              <p className="para">{userisLogged?.displayName}</p>
              <p className="mb-4 para mt-4 ">{userisLogged?.email}</p>
              <p className="para">
                <span className="text-uppercase">USER Id :</span>
                {userisLogged?.uid}
              </p>
            </div>
          </div>
          <div className="wallet-overview w-50 content-wrapper">
            <h2 className="body-medium text-center ">Wallet Overview</h2>

            <div className="vh-center h-100">
              <div className="left w-50 vh-center flex-column ">
                <p className="para text-center">Your Balance</p>
                <p className="para  text-center">
                  USDT
                  <span className="body-large ms-2">{tokenBalance}</span>
                </p>
              </div>
              <div className="right w-50">
                <button onClick={handleTokensApproval}>Approve</button>
              </div>
            </div>
          </div>
        </div>
        <div className=" btm-wrapper d-flex mt-4">
          <div className="content-wrapper refer d-flex flex-column justify-content-between w-50">
            <h2 className="body-medium text-center ">
              Referral program overview
            </h2>
            <p className="text-center para">
              Join Our Referral program and receive Referral In USDT
            </p>
            <div className="refer-link box">
              <div></div>
              <p className="para mb-0">www.astrality/wilson323661278</p>
              <img
                src="\assets\icons\copy.svg"
                alt="copy"
                className="cursor-pointer"
              />
            </div>
            <div className="box withdraw-btn v-center  mt-4">
              <div className="left vh-center flex-column w-50">
                <p className="para mb-0 body-large text-light-blue">
                  USDT 5123
                </p>
                <p className="para mb-0">Available to Withdraw </p>
              </div>
              <button>Widthdrawn</button>
            </div>

            <div className="d-flex justify-content-between ref-ern">
              <div className="box withdraw-btn v-center flex-column p-3 mt-4 w-50 me-3">
                <p className="para mb-0 body-large text-light-blue">
                  USDT 5123
                </p>
                <p className="para mb-0">Referrals </p>
              </div>
              <div className="box withdraw-btn v-center flex-column p-3 mt-4 w-50">
                <p className="para mb-0 body-large text-light-blue">
                  USDT 5123
                </p>
                <p className="para mb-0">Earned </p>
              </div>
            </div>
          </div>
          <div className="rentel content-wrapper  w-50 d-flex flex-column justify-content-between">
            <h2 className="body-medium text-center ">
              Rental Collected overview
            </h2>
            <div className="rentel-graph m-auto w-75">
              <Chart
                options={options}
                series={series}
                width="100%"
                height="242px"
                type="area"
              />
            </div>
            <h2 className="body-medium text-center ">
              Rent collected: {String(profit) ? profit : 0}
            </h2>
          </div>
        </div>

        {/* <div className="offer-recieved content-wrapper mt-4 ">
          <div className="offer-r-header  v-center justify-content-between">
            <h2 className="body-medium ">Offer recieved</h2>
            <button>See More..</button>
          </div>
          <div className="offer-table ">
            <div className="table-header ">
              <p className="para">Offer</p>
              <p className="para">Land</p>
              <p className="para">Size</p>
              <p className="para self-center"></p>
            </div>
            <div className="table-body">
              <div className="table-body-content mt-4">
                <p className="para mb-0 v-center ">USDT 543</p>
                <p className="para mb-0 v-center text-light-green">254,15,75</p>
                <p className="para mb-0 v-center ">1x1</p>
                <div className="self-center">
                  <button>View</button>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>

    </>
  );
};

export default Overview;
